import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const ActionSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-between gap-4 rounded-control border p-4', className);

	// Render
	return (
		<Card className={rootClassName}>
			<span className='flex-start gap-4 w-full'>
				<CardHeader className='aspect-[1/1] rounded-control w-24'>
					<Skeleton className='leading-[inherit]' />
				</CardHeader>
				<CardContent className='w-2/3'>
					<CardTitle>
						<Skeleton className='w-1/2' />
					</CardTitle>
					<CardDescription>
						<Skeleton className='w-3/4' />
					</CardDescription>
				</CardContent>
			</span>
			<span className='aspect-[1/1] w-8'>
				<Skeleton />
			</span>
		</Card>
	);
};
export { ActionSkeleton };
// Docs:
// https://github.com/dvtng/react-loading-s#readme
